import React, { useState, useEffect } from "react";
import Promocion from "./Promocion";
import { dbApp } from "../../firebase/config";
import Cargando from "../Cargando";
import Mensaje from "../Mensaje";

const ProductoInicio = () => {
  const [promociones, setPromociones] = useState([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    const getProductos = () => {
      setCargando(true);
      const resultadoProductos = [];
      dbApp
        .collection("promociones")
        .where("estatus", "==", "1")
        .get()
        .then((response) => {
          setCargando(false);
          response.forEach((doc) => {
            const producto = doc.data();
            producto.id = doc.id;
            resultadoProductos.push(producto);
          });
          setPromociones(resultadoProductos);
        })
        .catch(() => {
          setCargando(false);
        });
    };

    getProductos();
  }, []);

  let mostrar;

  if (cargando) {
    mostrar = <Cargando />;
  } else if (promociones.length <= 0) {
    mostrar = (
      <div className="mt-5">
        <Mensaje mensaje="No hay pizzas." />
      </div>
    );
  } else {
    mostrar = (
      <div className="card-deck">
        {promociones.map((promocion) => (
          <Promocion key={promocion.id} promocion={promocion} />
        ))}
      </div>
    );
  }

  console.log(promociones);
  return (
    <div className="mt-3">
      <div className="d-flex justify-content-center">
        <h2 className="titulo">LAS PROMOCIONES</h2>
      </div>
      {mostrar}
    </div>
  );
};

export default ProductoInicio;
